export default class CkCustomUploadAdapter {
  private loader: any;
  private handleBeforeUpload: (file: File) => boolean;
  private imageMapRef: React.MutableRefObject<Map<string, number>>;
  private setTotalImageSize: React.Dispatch<React.SetStateAction<number>>;
  private setImageData: React.Dispatch<React.SetStateAction<{ file: File; base64Data: string }[]>>;

  constructor(
    loader: any,
    handleBeforeUpload: (file: File) => boolean,
    imageMapRef: React.MutableRefObject<Map<string, number>>,
    setTotalImageSize: React.Dispatch<React.SetStateAction<number>>,
    setImageData: React.Dispatch<React.SetStateAction<{ file: File; base64Data: string }[]>>
  ) {
    this.loader = loader;
    this.handleBeforeUpload = handleBeforeUpload;
    this.imageMapRef = imageMapRef;
    this.setTotalImageSize = setTotalImageSize;
    this.setImageData = setImageData;
  }

  upload() {
    return this.loader.file.then(
      (file: File) =>
        new Promise((resolve, reject) => {
          if (!this.handleBeforeUpload(file)) {
            reject("Total limit exceeded");
            return;
          }

          const reader = new FileReader();
          reader.onload = () => {
            const src = reader.result as string;

             // Store full data URL in imageMap for size tracking
            this.imageMapRef.current.set(src, file.size);
            //Update total image size
            this.setTotalImageSize((prev) => prev + file.size);

            //Update imageData with consistent property name `src`
           // (avoid "base64Data" since editor <img> src matches "src")
           this.setImageData((prev) => [...prev, { file, src }]);
                
            resolve({ default: src });
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        })
    );
  }

  abort() {
    console.log("Upload aborted");
  }
}

